import { render, staticRenderFns } from "./classShuati.vue?vue&type=template&id=d670f314&scoped=true"
import script from "./classShuati.vue?vue&type=script&lang=js"
export * from "./classShuati.vue?vue&type=script&lang=js"
import style0 from "./classShuati.vue?vue&type=style&index=0&id=d670f314&prod&lang=scss"
import style1 from "./classShuati.vue?vue&type=style&index=1&id=d670f314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670f314",
  null
  
)

export default component.exports